import { Component } from '@angular/core';

@Component({
  selector: 'app-careers-hero-section',
  templateUrl: './careers-hero-section.component.html',
  styleUrls: ['./careers-hero-section.component.scss'],
  standalone: true,
})
export class CareersHeroSectionComponent {}
